export default "__VITE_ASSET__07M_xxc___"